import React, { useState, useEffect, useRef,useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { isLoggedIn } from '../../Services/Auth';
import { logPageViews } from '../../Services/LoginService.js';
import { GetGroupUser, RemoveGroupUser,NewGroupUser } from '../../Services/GroupUserServices.js';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { Row, Col, Container } from 'react-bootstrap';
import LandingPageBanner from '../LandingPageBanner.js';
import '../../styles/GroupUsers.scss'
import BootstrapModal from 'react-bootstrap/Modal';
import { Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Modal, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Paper, Alert, Divider, useMediaQuery, Box, Typography, IconButton, Button, TextField, FormControl, InputAdornment, Stepper, Step, StepLabel } from '@mui/material';
import { IconUserPlus, IconUsers, IconUnlink, IconUser, IconBuilding, IconBriefcase, IconMapPin, IconPhone, IconMail, IconLock, IconEye, IconEyeOff, IconLogin, IconCheck, IconArrowForward, IconArrowLeft, IconArrowRight, IconX, IconSearch } from '@tabler/icons-react';
import Drugs4DentLogo from '../../assets/Drugs4dent.svg';
import { useThemeManager } from '../../Context/ThemeManager.js';

const MyGroupList = () => {
  const {theme} = useThemeManager();
  const [loggedIn, setLoggedIn] = useState(false);
  const [inputGroupUser, setInputGroupUser] = useState([]);
  const [inputGroupUser2, setInputGroupUser2] = useState([]);
  const isLgScreen = useMediaQuery('(min-width:1024px)');
  const country = localStorage.getItem("Activecountryversion");
  useEffect(() => {
    document.title = "Manage Group Users Account"
    setLoggedIn(isLoggedIn());
    document.documentElement.style.setProperty('--primary-color', theme.primary);
        document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
        document.documentElement.style.setProperty('--buttonGradient', theme.buttonGradient);
        document.documentElement.style.setProperty('--bg', theme.bg);
    logPage();
    async function logPage() {
      await logPageViews('Manage Group Users Account', "")
      document.getElementById('loaderPage').style.display = 'flex'
      setInputGroupUser(await GetGroupUser())
      document.getElementById('loaderPage').style.display = 'none'
      console.log(inputGroupUser)

    }
  }, []);
  function RemoveUser(id) {
    logPage();
    async function logPage() {

      document.getElementById('loaderPage').style.display = 'flex'
      setInputGroupUser(await RemoveGroupUser(id))
      console.log ("Removed User:", id)
      document.getElementById('loaderPage').style.display = 'none'


    }
  }
  

  const [searchValue, setSearchValue] = useState("")

  const [groupUsers, setGroupUsers] = useState(inputGroupUser);
  useEffect(() => {
    setGroupUsers(inputGroupUser);
    //console.log(inputGroupUser)
  }, [inputGroupUser]);

  useEffect(() => {
    setGroupUsers(inputGroupUser);
    //console.log(groupUsers)
    if (searchValue === "") { setGroupUsers(inputGroupUser); return; }
    const filterBySearch = inputGroupUser.filter((item) => {
      if (item.email.toLowerCase().includes(searchValue.toLowerCase()) || item.fullName.toLowerCase().includes(searchValue.toLowerCase())) { return item; }
    })
    setGroupUsers(filterBySearch);
  }, [searchValue])
  const [openNew, setopenNew] = useState(false);
  const handleCloseNew = () => {
    setopenNew(false);
    setFormValues (initialFieldState)
    setError (initialErrorstate)
    setFocused (initialFocusState)
    setEmailErrorMessage ('')
  };
  const handleOpenNew = () => {
    setopenNew(true);
  };
  // Form fields
const formFields = useMemo(() => [
    { id: 'fullName', label: 'Full Name', icon: <IconUser sx={{ fontSize: 16, pl: '10px' }} />, type: 'text' },
    { id: 'email', label: 'Email', icon: <IconMail sx={{ fontSize: 16, pl: '10px' }} />, type: 'email' }
], []);
  // Sign up stepper
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Personal Information', 'Account Details'];
  // Form fields error states
  const initialErrorstate = formFields.reduce((acc, field) => {
    acc[field.id] = false;
    return acc;
  }, {});
  const [error, setError] = useState(initialErrorstate);
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
  const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState('');

  // Form fields states
  const initialFieldState = formFields.reduce((acc, field) => {
    acc[field.id] = '';
    return acc;
  }, {});
  const [formValues, setFormValues] = useState(initialFieldState);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [existingEmails, setExistingEmails] = useState([]);



  // Form fields focused states
  const initialFocusState = formFields.reduce((acc, field) => {
    acc[field.id] = false;
    return acc;
  }, {});
  const [focused, setFocused] = useState(initialFocusState);



  // Form fields label srhink states
  const initialShrinkState = formFields.reduce((acc, field) => {
    acc[field.id] = false;
    return acc;
  }, {});
  const [shrinked, setShrinked] = useState(initialShrinkState);
  // Sign up button disabler to prevent multiple clicks
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [token, setToken] = useState('')

  const handleInputChange = (fieldId) => (e) => {
    const { value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [fieldId]: value, }));
    setShrinked((prevShrinked) => ({ ...prevShrinked, [fieldId]: value !== '', }));
    setError((prevError) => ({ ...prevError, [fieldId]: false }));
    setFocused((prevFocused) => ({ ...prevFocused, [fieldId]: value !== '', }));

    if (fieldId === 'email') {
      setFocused((prevFocused) => ({ ...prevFocused, email: false, }));
      if (value.includes('@')) {
        if (!emailRegex.test(value)) {
          setError((prevState) => ({ ...prevState, email: true }));
          setEmailErrorMessage('Invalid email');
        } else {
          if (existingEmails.includes(value)) {
            setError((prevState) => ({ ...prevState, email: true }));
            setEmailErrorMessage('Email already exists');
            setFocused((prevFocused) => ({ ...prevFocused, email: false, }));
          } else {
            setError((prevState) => ({ ...prevState, email: false }));
            setEmailErrorMessage('');
            setFocused((prevFocused) => ({ ...prevFocused, email: true, }));
          }
        }
      } else {
        // Handle the case where '@' is not present (optional)
        setError((prevState) => ({ ...prevState, email: false }));
        setFocused((prevFocused) => ({ ...prevFocused, email: false, }));
      }
    }



  };

  // Shrink label when there's an autofill value 
  const makeAnimationStartHandler = (fieldId) => (e) => {
    const autofilled = !!e.target?.matches("*:-webkit-autofill");
    if (e.animationName === "mui-auto-fill" || e.animationName === "mui-auto-fill-cancel") {
      setShrinked((prevShrinked) => ({ ...prevShrinked, [fieldId]: autofilled || e.target.value !== '', }));
    }
  };

  async function verifySignup(event) {

    event.preventDefault();
    let isValid = true;
 
    // Validate each field based on formValues state
    formFields.forEach(field => {
      const fieldValue = formValues[field.id]?.trim();
      console.log(fieldValue)
      if (field.id === 'email') {
        if (formValues[field.id] === '') {
          setError(prevState => ({ ...prevState, [field.id]: true }));
          setEmailErrorMessage('Email is requiredsdf');
          isValid = false;
        } else if (!emailRegex.test(formValues[field.id])) {
          setError(prevState => ({ ...prevState, [field.id]: true }));
          setEmailErrorMessage('Invalid email');
          isValid = false;
        } else {
          if (existingEmails.includes(formValues[field.id])) {
            setError(prevState => ({ ...prevState, [field.id]: true }));
            setEmailErrorMessage('Email already exists');
            setFocused(prevFocused => ({ ...prevFocused, [field.id]: false, }));
            isValid = false;
          } else {
            setError(prevState => ({ ...prevState, [field.id]: false }));
            setEmailErrorMessage('');
            setFocused(prevFocused => ({ ...prevFocused, [field.id]: true, }));
          }
        }
      } else if (field.id === 'fullName') {
        if (formValues[field.id] === '') {
          setError(prevState => ({ ...prevState, [field.id]: true }));
          setPasswordErrorMessage('Name is required');
          setFormValues(prevValues => ({ ...prevValues, confirmPassword: '', }));
          setShrinked(prevShrinked => ({ ...prevShrinked, confirmPassword: false, }));
          isValid = false;
        }

        else {
          setError(prevState => ({ ...prevState, [field.id]: false }));
        }
      }
    });

    // If all validations pass, proceed to signup verification to check email existence
    if (isValid) {
      setIsButtonDisabled(true);
      document.getElementById('loaderPage').style.display = 'flex'
      try {
        const { email, password, fullName, companyName, occupation, address, phoneNumber } = formValues;
        setopenNew(false)
        const token = await NewGroupUser(email,fullName);
        //setToken(token)

        if(token[0].email == 'exist')
          {
            setError(prevState => ({ ...prevState, ['email']: true }));
            setEmailErrorMessage('Email already exists');
            setFocused(prevFocused => ({ ...prevFocused, ['email']: false, }));
            setopenNew(true)
          }else{
            setInputGroupUser(token)
            setopenNew(false)
          }

        //setopenNew(false)
        //setInputGroupUser(token)
      } catch (error) {
        // Handle signup error
        console.error('Signup failed:', error);
        // Optionally, set error state or handle error UI
      }
      finally {
        document.getElementById('loaderPage').style.display = 'none'
        setIsButtonDisabled(false); // Re-enable the button after the process is complete
        console.log(token)
        
      }
    }
  };
  const [modalTitle, setModalTitle] = useState('')
  const [modalBody, setModalBody] = useState('')
  const [userID, setUserID] = useState('')
  const [userFullName, setUserFullName] = useState('')
  const [userEmail, setUserEmail] = useState('')
  const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);
    function RemoveUserModal(props) {
        return (
          <BootstrapModal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="resultsModal"
            dialogClassName={isLgScreen ? "" : "modal-dialog-scrollable"}
          >
            <BootstrapModal.Header closeButton>
              <BootstrapModal.Title className="d-flex align-items-center flex-nowrap w-100">
                <IconUnlink color='#727272'/>
                <h5 className="mb-0 ms-1" style={{ fontSize: !isLgScreen ? 16 : "" }}>
                  Unlink User
                </h5>
              </BootstrapModal.Title>
            </BootstrapModal.Header>

            <BootstrapModal.Body>
               <h5
                  style={{
                    lineHeight: 1.5,
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                  }}
                >
                Are you sure you want to unlink
                <span style={{ color: theme.primary }}> {userFullName}</span> (
                <span style={{ fontWeight: "bold", color: theme.primary }}>{userEmail}</span>)
                from the group?
              </h5>
            </BootstrapModal.Body>

            <BootstrapModal.Footer
              style={{
                display: "flex",
                gap: "8px",
                width: "100%",
                flexWrap: "wrap",
                paddingTop: "20px"
              }}
            >
              <Button
                variant="text"
                onClick={() => {
                    setShowRemoveUserModal(false);
                    setUserID("");
                    setUserFullName ("");
                    setUserEmail ("")
                  }}
                sx={{
                  flex: 1,
                  borderRadius: "12px",
                  padding: "12px",
                  minWidth: "fit-content",
                  whiteSpace: "nowrap",
                  color: "text.secondary",
                  fontWeight: "bold"
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                type="submit"
                color="error"
                onClick={() => RemoveUser(userID)}
                sx={{
                  flex: 1,
                  borderRadius: "12px",
                  minWidth: "fit-content",
                  padding: "12px",
                  whiteSpace: "nowrap"
                }}
                startIcon={<IconUnlink />}
              >
                Unlink
              </Button>
            </BootstrapModal.Footer>
          </BootstrapModal>
        );
    }
   

  return (<>
  <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Helmet>
  <RemoveUserModal
    show={showRemoveUserModal}
    onHide={() => {
        setShowRemoveUserModal(false);
        setUserID("");
        setUserFullName ("");
        setUserEmail ("")
      }}
  />
  <Dialog 
    id="addUserModal"
    open={openNew}
    onClose={handleCloseNew}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    >
     <DialogTitle
        id="alert-dialog-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pr: 1, // add some padding to the right for the close button
        }}
      >
        <div className='d-flex'>
        <IconUserPlus color={theme.primary}/>
        <h5 style={{ color: theme.primary,fontWeight: "bold", marginBottom: 0, marginLeft:"12px"}}>
          Add New User
        </h5>

        </div>

        <IconButton
          aria-label="close"
          onClick={handleCloseNew}
          sx={{ color: 'grey.500' }}
        >
          <IconX />
        </IconButton>
      </DialogTitle>
      <hr className='my-0 mx-3'/>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Fill up the user credentials to add new user
        </DialogContentText>
        <Box sx={{ width: '100%' }} id="signupForm">
  
                <>
                  <form>
                    {formFields.slice(0, 5).map((field) => (
                      <FormControl margin="normal" required fullWidth error={error[field.id]} key={field.id}>
                        <TextField
                          id={field.id}
                          name={field.id}
                          type={field.type}
                          label={field.label}
                          variant="outlined"
                          value={formValues[field.id]}
                          onChange={(e) => {
                            if (field.id === 'phoneNumber') {
                              const re = /^[0-9\b]+$/;
                              if (e.target.value === '' || re.test(e.target.value)) {
                                handleInputChange(field.id)(e);
                              }
                            } else {
                              handleInputChange(field.id)(e);
                            }
                          }}
                          fullWidth
                          focused={focused[field.id]}
                          error={error[field.id]}
                          helperText={ 
                            field.id === 'email' ? emailErrorMessage :
                            
                            error[field.id] ? `${field.label} is required` : ''}
                          InputProps={{
                            onAnimationStart: makeAnimationStartHandler(field.id),
                            startAdornment: <InputAdornment position="start">{field.icon}</InputAdornment>,
                            endAdornment: focused[field.id] ? (
                              <InputAdornment position="end">
                                <IconCheck className='validIcon' />
                              </InputAdornment>
                            ) : null,
                          }}
                          InputLabelProps={{
                            shrink: shrinked[field.id],
                            sx: { fontWeight: 'bold' },
                          }}
                        />
                      </FormControl>
                    ))}
                    
                  </form>
                </>
            </Box>
      </DialogContent>
      <DialogActions sx={{p:3}}>
          <Button fullWidth type="text" onClick={handleCloseNew} sx={{color: "#727272"}}>Cancel</Button>
          <Button disabled={isButtonDisabled} variant="contained" type="submit" onClick={verifySignup} className='proceedButton mt-2' fullWidth startIcon={<IconUserPlus/>}
          sx={{
              py: 1,
              px: 2,
              bgcolor: theme.primary,
              color: "#fff",
              borderRadius: '12px',
              color: "#fff"
              }}>
            Add User
          </Button>
      </DialogActions>
  </Dialog>
  <Banner /> 
  <Sidebar />
  <div id="GroupUsers">              
    <Container fluid id="main">
      <div id="content">
            <div id="contentCaption">
              <h2 style={{fontWeight: "bold"}}>Manage Group Users Account</h2>
            </div>
           <Row id="usersContainer" className={ isLgScreen ? 'mt-4 mx-0 d-flex' : ''}>
             <div className= { isLgScreen ? 'd-flex p-0' : 'd-flex px-2 mt-2'} style={{color: theme.primary}}>
                  <IconUsers style={{marginRight: 8}}/>
                  <h5 style={{ fontWeight: "bold", marginBottom: 0}}>
                      Users Management
                  </h5>
              </div>
              <hr className='my-3'/>
            <div className= {isLgScreen ? "d-flex justify-content-between align-items-center w-100 px-0" : "d-flex justify-content-between align-items-center w-100 px-2"} >
             <TextField 
              size='small'
              sx={{width: isLgScreen ? '40ch' : '25ch', fontSize: isLgScreen ? "" : "12px"}}
              id="outlined-basic" 
              label={searchValue === '' 
                    ? (isLgScreen ? 'Search by name or email' : 'Search Users') 
                    : 'Search Users'}
              variant="outlined"
              onChange={(e) => setSearchValue(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size={isLgScreen ? 20:16}/>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                shrink: searchValue !== '',
                 sx: {
                    fontSize: isLgScreen ? undefined : '0.75rem', // adjust font size when not large screen
                    pl: searchValue === '' 
                    ? (isLgScreen ? '28px' : '24px') 
                    : undefined,

                  },
              }}
            />
            <Button
              onClick={handleOpenNew}
              variant="contained"
              sx={{
              py: 1,
              px: 2,
              bgcolor: theme.primary,
              color: "#fff",
              borderRadius: '12px',
              fontSize: isLgScreen ? "" : "12px"
              }}
              startIcon={<IconUserPlus size={isLgScreen ? 20:16}/>}
            >
                Add User
            </Button>
           
             
            </div>
               {isLgScreen ? (<>
                            {groupUsers.length > 0 &&
                        <TableContainer component={Paper} sx={{ mt: 2 }} >
                            <Table aria-label="simple table" >
                                <TableHead>
                                  <TableRow >
                                      <TableCell sx={{fontWeight: "bold"}} style={{paddingTop: "16px", paddingBottom: "16px"}}>Email</TableCell>
                                      <TableCell sx={{fontWeight: "bold"}} style={{paddingTop: "16px", paddingBottom: "16px"}}>First Name</TableCell>
                                      <TableCell align="center" sx={{fontWeight: "bold"}} style={{paddingTop: "16px", paddingBottom: "16px"}}>Actions</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                {groupUsers.map(val => (
                                    <TableRow>
                                      <TableCell className='email'>{val.email}</TableCell>
                                      <TableCell >{val.fullName}</TableCell>
                                      <TableCell align="center">
                                        {val.userType != "2" && val.is_group_default == false &&
                                          <Button
                                            variant="contained"
                                            color= "error"
                                            onClick={() => {
                                              setShowRemoveUserModal(true);
                                              setUserID(val.id);
                                              setUserFullName (val.fullName);
                                              setUserEmail (val.email)
                                            }}
                                            sx={{
                                            py: 1,
                                            px: 2,
                                            borderRadius: '12px',
                                            textTransform: "none",
                                            fontSize: 12
                                            }}
                                            startIcon={<IconUnlink/>}
                                          >
                                              Unlink From Group
                                          </Button>
                                        }
                                      </TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                          }
                        </>) : (<>
                        
                        <Box width={"100%"} >
                          <Row className='mt-3 py-2'style={{ fontSize: 10, fontWeight: "bold", alignItems: "center", backgroundColor: "#dee2e6",  }}>
                              <Col xs={8} md={8}>
                                  <span>User</span>
                              </Col>
                              <Col xs={4} md={4} style={{textAlign: "center", paddingLeft: 0}}>
                              <span> Actions </span>
                              </Col>
                          </Row>
                          { groupUsers.map(val => (
                            <Row
                                className='mobileRows'
                                style={{ fontSize: 12 }}
                            >
                                <Col xs={8} md={8} className='d-flex flex-column'>
                                <span >
                                {val.fullName}
                                </span>
                                <span style={{color: theme.primary, fontWeight: "bold"}}>
                                {val.email}
                                </span>
                                </Col>
                                <Col xs={4} md={4} style={{display: "flex", alignItems:"center", justifyContent: "center", margin: "4px 0", padding:0}}>
                                    {val.userType != "2" && val.is_group_default == false &&
                                      <Button
                                        variant="contained"
                                        color= "error"
                                        size='small'
                                        onClick={() => {
                                          setShowRemoveUserModal(true);
                                          setUserID(val.id);
                                          setUserFullName (val.fullName);
                                          setUserEmail (val.email)
                                        }}
                                        sx={{
                                        borderRadius: '12px',
                                        textTransform: "none",
                                        fontSize: 12
                                        }}
                                        startIcon={<IconUnlink size={16}/>}
                                      >
                                          Unlink
                                      </Button>
                                    }
                                
                                </Col>
                                <hr className='m-0 mt-2'/> 
                            </Row>
                                  
                          ))}
                        </Box>
                        </>)}
          </Row>
      </div>
    </Container>
  </div>
  </>);
}

export default MyGroupList;